import { createRouter, createWebHistory } from 'vue-router';
// import CustomVueRouter from './customVueRouter';  // TODO: Rewrite for Vue Router 4 in next commit

/*import UserDevices from '../views/UserDevices';
import UserDevice from '../views/UserDevice';*/

// Games

// Admin
// New admin

// Partner

// Sales Admin

const prefixRoutes = (prefix, routes) => routes.map((route) => {
  route.path = prefix + route.path;
  return route;
});

const router = createRouter({
  history: createWebHistory(),
  // scrollBehavior (to, from, savedPosition) {
  scrollBehavior(to, from) {
    // Skip if destination full path has query parameters and differs in no other way from previous
    if (from && Object.keys(to.query).length) {
      if (to.fullPath.split('?')[0] == from.fullPath.split('?')[0]) return;
    }

    return { left: 0, top: 0 }
  },

  routes: [
    {
      path: '/',
      name: 'EnginioLanding',
      component: () => import('../views/EnginioLanding'),
    },
    {
      path: '/consumer',
      name: 'MarketPicker',
      component: () => import('../views/LanguagePickerView'),
    },
  ].concat(prefixRoutes(`/:market`, [
    // Home
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home'),
    },
    {
      path: '/company/:companyId',
      redirect: { name: 'HomeCompany' },
    },
    {
      path: '/e/:companyId',
      name: 'HomeCompany',
      component: () => import('../views/HomeCompany'),
      props: true,
    },
    {
      path: '/goodiebag/:goodiebagId',
      redirect: { name: 'HomeGoodiebag' },
    },
    {
      path: '/c/:goodiebagId',
      name: 'HomeGoodiebag',
      component: () => import('../views/HomeGoodiebag'),
      props: true,
    },
    {
      path: '/offer/:offerId',
      redirect: { name: 'HomeOffer' },
    },
    {
      path: '/a/:offerId',
      name: 'HomeOffer',
      component: () => import('../views/HomeOffer'),
      props: true,
    },
    {
      path: '/info',
      name: 'HomeInfo',
      component: () => import('../views/HomeInfo'),
      children: [
        {
          path: 'company',
          // component: UserProfileSettings,
        },
      ]
    },
    {
      path: '/data',
      name: 'HomeData',
      component: () => import('../views/HomeData'),
    },
    {
      name: 'HomeData.cookies',
      path: '/data/cookies',
      component: () => import('../views/HomeDataCookies'),
    },
    {
      name: 'HomeData.visitors',
      path: '/data/visitors',
      component: () => import('../views/HomeDataVisitors'),
    },
    {
      name: 'HomeData.members',
      path: '/data/members',
      component: () => import('../views/HomeDataMembers'),
    },
    {
      name: 'HomeData.participants',
      path: '/data/participations',
      component: () => import('../views/HomeDataParticipants'),
    },
    {
      name: 'HomeData.terms',
      path: '/data/terms',
      component: () => import('../views/HomeDataTerms'),
    },
    {
      name: 'HomeData.companies',
      path: '/data/companies',
      component: () => import('../views/HomeDataCompanies'),
    },

    {
      path: '/faq/:companyId',
      name: 'HomeFAQ',
      component: () => import('../views/HomeFAQ'),
      props: true,
    },
    {
      path: '/email',
      name: 'HomeEmail',
      component: () => import('../views/HomeEmail'),
    },
    {
      path: '/close',
      name: 'HomeClose',
      component: () => import('../views/HomeClose'),
    },
    {
      path: '/429',
      name: 'Home429',
      component: () => import('../views/Home429'),
    },

    // Games
    // QrHunt
    {
      path: '/g/qr-hunt/:gameId',
      name: 'QrHuntHome',
      component: () => import('../games/QrHunt/QrHuntHome'),
      props: true,
    },
    {
      path: '/g/qr-hunt/:gameId/onboarding',
      name: 'QrHuntOnboarding',
      component: () => import('../games/QrHunt/QrHuntOnboarding'),
      props: true,
    },
    {
      path: '/g/qr-hunt/:gameId/error',
      name: 'QrHuntError',
      component: () => import('../games/QrHunt/QrHuntError'),
      props: true,
    },

    // LoyaltyShop
    {
      path: '/g/loyalty-shop/:gameId',
      name: 'LoyaltyShopHome',
      component: () => import('../games/LoyaltyShop/LoyaltyShopHome'),
      props: true,
    },
    {
      path: '/g/loyalty-shop/:gameId/onboarding',
      name: 'LoyaltyShopOnboarding',
      component: () => import('../games/LoyaltyShop/LoyaltyShopOnboarding'),
      props: true,
    },
    {
      path: '/g/loyalty-shop/:gameId/error',
      name: 'LoyaltyShopError',
      component: () => import('../games/LoyaltyShop/LoyaltyShopError'),
      props: true,
    },

    // WebShop
    {
      path: '/g/web-shop/:gameId',
      name: 'WebShopHome',
      component: () => import('../games/WebShop/WebShopHome'),
      props: true,
    },
    {
      path: '/g/web-shop/:gameId/onboarding',
      name: 'WebShopOnboarding',
      component: () => import('../games/WebShop/WebShopOnboarding'),
      props: true,
    },
    {
      path: '/g/web-shop/:gameId/error',
      name: 'WebShopError',
      component: () => import('../games/WebShop/WebShopError'),
      props: true,
    },

    // Spin
    {
      path: '/g/spin/:gameId',
      name: 'SpinHome',
      component: () => import('../games/Spin/SpinHome'),
      props: true,
    },
    {
      path: '/g/spin/:gameId/onboarding',
      name: 'SpinOnboarding',
      component: () => import('../games/Spin/SpinOnboarding'),
      props: true,
    },
    {
      path: '/g/spin/:gameId/error',
      name: 'SpinError',
      component: () => import('../games/Spin/SpinError'),
      props: true,
    },

    // Scratch
    {
      path: '/g/scratch/:gameId',
      name: 'ScratchHome',
      component: () => import('../games/Scratch/ScratchHome'),
      props: true,
    },
    {
      path: '/g/scratch/:gameId/onboarding',
      name: 'ScratchOnboarding',
      component: () => import('../games/Scratch/ScratchOnboarding'),
      props: true,
    },
    {
      path: '/g/scratch/:gameId/error',
      name: 'ScratchError',
      component: () => import('../games/Scratch/ScratchError'),
      props: true,
    },

    // Consumer views
    {
      path: '/u-start',
      redirect: { name: 'UserStart' },
    },
    {
      path: '/u-st',
      name: 'UserStart',
      component: () => import('../views/UserStart'),
    },
    {
      path: '/u-company/:companyId',
      redirect: { name: 'UserStart' },
    },
    {
      path: '/u-e/:companyId',
      name: 'UserCompany',
      component: () => import('../views/UserCompany'),
      props: true,
    },
    {
      path: '/u-goodiebag/:goodiebagId',
      redirect: { name: 'UserGoodiebag' },
    },
    {
      path: '/u-c/:goodiebagId',
      name: 'UserGoodiebag',
      component: () => import('../views/UserGoodiebag'),
      props: true,
    },
    {
      path: '/u-offer/:offerId',
      redirect: { name: 'UserOffer' },
    },
    {
      path: '/u-a/:offerId',
      name: 'UserOffer',
      component: () => import('../views/UserOffer'),
      props: true,
    },

    // Purchase validation
    {
      // path: '/pv/:pvId/:previousOfferId?', when we want to remove the previousOfferId
      path: '/pv/:pvId/:previousOfferId?',
      name: 'UserPV',
      component: () => import('../views/UserPV'),
      props: true,
    },
    {
      path: '/pv2/:activationId/:previousOfferId?',
      redirect: (to) => ({
        name: 'UserPV',
        params: {
          market: to.params.market,
          pvId: to.params.activationId,
          previousOfferId: to.params.previousOfferId,
        },
      }),
    },

    {
      path: '/u-profile',
      redirect: { name: 'UserProfile' },
    },
    {
      path: '/u-p',
      name: 'UserProfile',
      component: () => import('../views/UserProfile'),
      children: [
        {
          path: 'shared',
          name: 'UserSharedData',
          component: () => import('../views/UserSharedData'),
        },
        {
          path: 'activations',
          name: 'UserActivations',
          component: () => import('../views/UserActivations'),
        },
        {
          path: 'history',
          name: 'UserHistory',
          component: () => import('../views/UserHistory'),
        },
        {
          path: 'receipts',
          name: 'UserReceiptStatus',
          component: () => import('../views/UserReceiptStatus'),
        },
        {
          path: 'cashbacks',
          name: 'UserCashbacks',
          component: () => import('../views/UserCashbacks'),
        }
      ]
    },
    {
      path: '/u-settings',
      redirect: { name: 'UserSettings' },
    },
    {
      path: '/u-set',
      name: 'UserSettings',
      component: () => import('../views/UserSettings'),
    },
    {
      path: '/u-p/club/:companyId',
      name: 'UserClubProfile',
      component: () => import('../views/UserClubProfile'),
      props: true,
      children: [
        {
          path: 'products',
          name: 'UserClubMyProducts',
          props: true,
          component: () => import('../views/UserClubProfileMyProducts'),
        },
        {
          path: 'favorites',
          name: 'UserClubMyFavorites',
          props: true,
          component: () => import('../views/UserClubProfileMyFavorites'),
        },
        {
          path: 'history',
          name: 'UserClubMyHistory',
          props: true,
          component: () => import('../views/UserClubProfileMyHistory'),
        },
        {
          path: 'about',
          name: 'UserClubAbout',
          props: true,
          component: () => import('../views/UserClubProfileAbout'),
        }
      ]
    },
    /*{
      path: '/u-devices',
      name: 'UserDevices',
      component: UserDevices,
    },
    {
      path: '/u-devices/:deviceName',
      name: 'UserDevice',
      component: UserDevice,
      props: true
    },*/
    {
      path: '/u-email',
      name: 'UserEmail',
      component: () => import('../views/UserEmail'),
    },

    // Admin views
    // New admin
    {
      path: '/admin',
      name: 'AdminHome',
      component: () => import('../views/AdminHome'),
    },
    {
      path: '/admin/archived',
      name: 'AdminArchived',
      component: () => import('../views/AdminArchived'),
    },
    {
      path: '/admin/draft',
      name: 'AdminDrafts',
      component: () => import('../views/AdminDrafts'),
    },
    {
      path: '/admin/dashboard',
      name: 'AdminDashboard',
      component: () => import('../views/AdminDashboard'),
    },
    {
      path: '/admin/statistics',
      name: 'AdminStatistics',
      component: () => import('../views/AdminStatistics'),
    },
    {
      path: '/admin/parent-companies',
      name: 'AdminParentCompanies',
      component: () => import('../views/AdminParentCompanies'),
    },
    {
      path: '/admin/parent-companies/:parentCompanyId',
      name: 'AdminParentCompany',
      component: () => import('../views/AdminParentCompany'),
      props: true,
    },
    {
      path: '/admin/companies',
      name: 'AdminCompanies',
      component: () => import('../views/AdminCompanies'),
    },
    {
      path: '/admin/companies/:companyId',
      name: 'AdminCompany',
      component: () => import('../views/AdminCompany'),
      props: true,
    },
    {
      path: '/admin/companies/:companyId/contentcreator',
      name: 'AdminCompanyContentCreator',
      component: () => import('../views/AdminCompanyContentCreator'),
      props: true,
    },
    {
      path: '/admin/companies/:companyId/economy',
      name: 'AdminCompanyEconomy',
      component: () => import('../views/AdminCompanyEconomy'),
      props: true,
    },
    {
      path: '/admin/companies/:companyId/statistics',
      name: 'AdminCompanyStatistics',
      component: () => import('../views/AdminCompanyStatistics'),
      props: true,
    },
    {
      path: '/admin/goodiebags',
      name: 'AdminGoodiebags',
      component: () => import('../views/AdminGoodiebags')
    },
    {
      path: '/admin/goodiebags/:goodiebagId',
      name: 'AdminGoodiebag',
      component: () => import('../views/AdminGoodiebag'),
      props: true,
    },
    {
      path: '/admin/games',
      name: 'AdminGamePicker',
      component: () => import('../views/AdminGamePicker'),
    },
    {
      path: '/admin/games/:gameType',
      name: 'AdminGames',
      component: () => import('../views/AdminGames'),
      props: true,
    },
    {
      path: '/admin/games/:gameType/:gameId',
      name: 'AdminGame',
      component: () => import('../views/AdminGame'),
      props: true
    },

    // Participations
    {
      path: '/admin/participations',
      name: 'AdminGameParticipations',
      component: () => import('../views/AdminGameParticipations'),
    },
    {
      path: '/admin/participations/:participationId',
      name: 'AdminGameParticipation',
      component: () => import('../views/AdminGameParticipation'),
      props: true,
    },

    // Translations
    {
      path: '/admin/translations',
      name: 'AdminTranslations',
      component: () => import('../views/AdminTranslations'),
    },

    // Legal Documents
    {
      path: '/admin/legal-documents',
      name: 'AdminLegalDocuments',
      component: () => import('../views/AdminLegalDocuments'),
    },
    {
      path: '/admin/legal-documents/:legalDocumentId',
      name: 'AdminLegalDocument',
      component: () => import('../views/AdminLegalDocument'),
      props: true,
    },

    // Terms
    {
      path: '/admin/terms',
      name: 'AdminTerms',
      component: () => import('../views/AdminTerms'),
    },
    {
      path: '/admin/terms/:termId',
      name: 'AdminTerm',
      component: () => import('../views/AdminTerm'),
      props: true,
    },

    {
      path: '/admin/offers',
      name: 'AdminOffers',
      component: () => import('../views/AdminOffers')
    },
    {
      path: '/admin/offers/:offerId',
      name: 'AdminOffer',
      component: () => import('../views/AdminOffer'),
      props: true,
    },
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: () => import('../views/AdminUsers'),
    },
    {
      path: '/admin/users/:userId',
      name: 'AdminUser',
      component: () => import('../views/AdminUser'),
      props: true,
    },
    {
      path: '/admin/hyperlinks',
      name: 'AdminHyperlinks',
      component: () => import('../views/AdminHyperlinks'),
    },
    {
      path: '/admin/hyperlinks/:hyperlinkId',
      name: 'AdminHyperlink',
      component: () => import('../views/AdminHyperlink'),
      props: true,
    },
    {
      path: '/admin/links-manager',
      name: 'AdminLinksManager',
      component: () => import('../views/AdminLinksManager'),
    },
    {
      path: '/admin/links-manager/comp/:companyId',
      name: 'AdminLinksManagerCompany',
      component: () => import('../views/AdminLinksManagerCompany'),
      props: true,
    },
    {
      path: '/admin/links-manager/coll/:goodiebagId',
      name: 'AdminLinksManagerGoodiebag',
      component: () => import('../views/AdminLinksManagerGoodiebag'),
      props: true,
    },
    {
      path: '/admin/links-manager/acti/:offerId',
      name: 'AdminLinksManagerOffer',
      component: () => import('../views/AdminLinksManagerOffer'),
      props: true,
    },
    {
      path: '/admin/communications-manager',
      name: 'AdminCommunicationPicker',
      component: () => import('../views/AdminCommunicationPicker'),
    },
    {
      path: '/admin/communications',
      name: 'AdminCommunications',
      component: () => import('../views/AdminCommunications'),
    },
    {
      path: '/admin/communications/:communicationId',
      name: 'AdminCommunication',
      component: () => import('../views/AdminCommunication'),
      props: true,
    },

    // PV
    {
      path: '/admin/pv',
      name: 'AdminPVHome',
      component: () => import('../views/AdminPVHome'),
    },
    {
      path: '/admin/pv/companies',
      name: 'AdminPVCompanies',
      component: () => import('../views/AdminPVCompanies'),
    },
    {
      path: '/admin/pv/companies/:companyId',
      name: 'AdminPVCompany',
      component: () => import('../views/AdminPVCompany'),
      props: true,
    },
    {
      path: '/admin/pv/campaigns',
      name: 'AdminPVCampaigns',
      component: () => import('../views/AdminPVCampaigns'),
    },
    {
      path: '/admin/pv/campaigns/:campaignId',
      name: 'AdminPVCampaign',
      component: () => import('../views/AdminPVCampaign'),
      props: true,
    },
    {
      path: '/admin/pv/activations',
      name: 'AdminPVActivations',
      component: () => import('../views/AdminPVActivations'),
    },
    {
      path: '/admin/pv/activations/:activationId',
      name: 'AdminPVActivation',
      component: () => import('../views/AdminPVActivation'),
      props: true,
    },
    {
      path: '/admin/pv/receipts',
      name: 'AdminPVReceipts',
      component: () => import('../views/AdminPVReceipts'),
    },
    {
      path: '/admin/pv/receipts/:receiptId',
      name: 'AdminPVReceipt',
      component: () => import('../views/AdminPVReceipt'),
      props: true,
    },
    {
      path: '/admin/pv/cashbacks',
      name: 'AdminPVCashbacks',
      component: () => import('../views/AdminPVCashbacks'),
    },
    {
      path: '/admin/pv/reviews',
      name: 'AdminPVReviews',
      component: () => import('../views/AdminPVReviews'),
    },
    {
      path: '/admin/pv/chains',
      name: 'AdminPVChains',
      component: () => import('../views/AdminPVChains'),
    },
    {
      path: '/admin/pv/chains/:chainId',
      name: 'AdminPVChain',
      component: () => import('../views/AdminPVChain'),
      props: true,
    },
    {
      path: '/admin/pv/retailers',
      name: 'AdminPVRetailers',
      component: () => import('../views/AdminPVRetailers'),
    },
    {
      path: '/admin/pv/retailers/:retailerId',
      name: 'AdminPVRetailer',
      component: () => import('../views/AdminPVRetailer'),
      props: true,
    },
    {
      path: '/admin/pv/stores',
      name: 'AdminPVStores',
      component: () => import('../views/AdminPVStores'),
    },
    {
      path: '/admin/pv/stores/:storeId',
      name: 'AdminPVStore',
      component: () => import('../views/AdminPVStore'),
      props: true,
    },
    {
      path: '/admin/pv/flagged',
      name: 'AdminPVFlagged',
      component: () => import('../views/AdminPVFlagged'),
    },
    {
      path: '/admin/pv/blocked',
      name: 'AdminPVBlocked',
      component: () => import('../views/AdminPVBlocked'),
    },

    // Company views
    {
      path: '/partner',
      name: 'PartnerHome',
      component: () => import('../views/PartnerHome'),
    },
    {
      path: '/new-company',
      name: 'PartnerPicker',
      component: () => import('../views/PartnerPicker'),
    },
    {
      path: '/c-activations/:activationId',
      name: 'PartnerActivation',
      component: () => import('../views/PartnerActivation'),
      props: true,
    },
    {
      path: '/c-collections/:collectionId',
      name: 'PartnerCollection',
      component: () => import('../views/PartnerCollection'),
      props: true,
    },
    {
      path: '/c-collections',
      name: 'PartnerCollections',
      component: () => import('../views/PartnerCollections'),
    },
    {
      path: '/c-e',
      name: 'PartnerCompany',
      component: () => import('../views/PartnerCompany'),
    },
    {
      path: '/c-c/:goodiebagId',
      name: 'PartnerGoodiebag',
      component: () => import('../views/PartnerGoodiebag'),
      props: true,
    },
    {
      path: '/c-a/:offerId',
      name: 'PartnerOffer',
      component: () => import('../views/PartnerOffer'),
      props: true,
    },
    {
      path: '/c-archived',
      name: 'PartnerArchived',
      component: () => import('../views/PartnerArchived'),
    },
    {
      path: '/c-dashboard',
      name: 'PartnerDashboard',
      component: () => import('../views/PartnerDashboard'),
    },
    {
      path: '/c-users/list/:companyId',
      name: 'PartnerUsers',
      component: () => import('../views/PartnerUsers'),
      props: true,
    },
    {
      path: '/c-users/:userId',
      name: 'PartnerUser',
      component: () => import('../views/PartnerUser'),
      props: true,
    },
    {
      path: '/c-dashboard/collections/:collectionId',
      name: 'PartnerDashboardCollection',
      component: () => import('../views/PartnerDashboardCollection'),
      props: true,
    },
    {
      path: '/c-dashboard/activations/:activationId',
      name: 'PartnerDashboardActivation',
      component: () => import('../views/PartnerDashboardActivation'),
      props: true,
      // Built on the new UI layer, so it opts out of the legacy island in the partner layout.
      meta: { uiRoot: true },
    },
    {
      path: '/c-products',
      name: 'PartnerProducts',
      component: () => import('../views/PartnerProducts'),
      // Built on the new UI layer, so it opts out of the legacy island in the partner layout.
      meta: { uiRoot: true },
    },
    {
      path: '/c-products/categories/:categoryId',
      name: 'PartnerProductCategory',
      component: () => import('../views/PartnerProductCategory'),
      props: true,
      meta: { uiRoot: true },
    },
    {
      path: '/c-products/:productId',
      name: 'PartnerProduct',
      component: () => import('../views/PartnerProduct'),
      props: true,
      meta: { uiRoot: true },
    },
    {
      path: '/c-settings/:companyId',
      name: 'PartnerSettings',
      component: () => import('../views/PartnerSettings'),
      props: true,
    },
    {
      path: '/c-support',
      name: 'PartnerSupport',
      component: () => import('../views/PartnerSupport'),
    },
    {
      path: '/c-participations',
      name: 'PartnerGameParticipations',
      component: () => import('../views/PartnerGameParticipations'),
    },
    {
      path: '/c-participations/:participationId',
      name: 'PartnerGameParticipation',
      component: () => import('../views/PartnerGameParticipation'),
      props: true,
    },
    {
      path: '/c-receipts',
      name: 'PartnerPVReceipts',
      component: () => import('../views/PartnerPVReceipts'),
    },
    {
      path: '/c-receipts/:receiptId',
      name: 'PartnerPVReceipt',
      component: () => import('../views/PartnerPVReceipt'),
      props: true,
    },

    // Sales Admin
    {
      path: '/admin/sales',
      name: 'AdminSales',
      component: () => import('../views/AdminSales.vue'),
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: '/admin/sales/articles',
      name: 'AdminArticleMaster',
      component: () => import('../views/AdminArticleMaster.vue'),
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: '/admin/sales/articles/:articleId?',
      name: 'AdminArticle',
      component: () => import('../views/AdminArticle.vue'),
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: '/admin/sales/v2',
      component: () => import('@/views/v2/SalesHome.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
      children: [
        {
          path: '',
          name: 'AdminSalesV2',
          redirect: 'quotes'
        },
        {
          path: 'articles',
          name: 'admin-v2-articles',
          component: () => import('@/views/v2/ArticleManager.vue')
        },
        {
          path: 'articles/create',
          name: 'admin-v2-articles-create',
          component: () => import('@/views/v2/ArticleEditor.vue')
        },
        {
          path: 'articles/:articleId',
          name: 'admin-v2-articles-edit',
          component: () => import('@/views/v2/ArticleEditor.vue'),
          props: true
        },
        {
          path: 'packages',
          name: 'admin-v2-packages',
          component: () => import('@/views/v2/PackageManager.vue')
        },
        {
          path: 'packages/create',
          name: 'admin-v2-packages-create',
          component: () => import('@/views/v2/PackageEditor.vue')
        },
        {
          path: 'packages/:id',
          name: 'admin-v2-packages-edit',
          component: () => import('@/views/v2/PackageEditor.vue'),
          props: true
        },
        {
          path: 'quotes',
          name: 'admin-v2-quotes',
          component: () => import('@/views/v2/QuoteManager.vue')
        },
        {
          path: 'quotes/create',
          name: 'admin-v2-quotes-create',
          component: () => import('@/views/v2/QuoteEditor.vue')
        },
        {
          path: 'quotes/:quoteId/edit',
          name: 'admin-v2-quotes-edit',
          component: () => import('@/views/v2/QuoteEditor.vue'),
          props: true
        },
        {
          path: 'quotes/:quoteId',
          name: 'admin-v2-quotes-view',
          component: () => import('@/views/v2/QuoteView.vue'),
          props: true
        },
        {
          path: 'budget',
          name: 'admin-v2-budget',
          component: () => import('@/views/v2/SalesBudget.vue')
        },
        {
          path: 'gantt',
          name: 'admin-v2-gantt',
          component: () => import('@/views/v2/SalesGantt.vue')
        }
      ]
    },

    /**
     * Redirect to home if it does not find the route
    */
    {
      path: '/:pathMatch(.*)*',
      name: 'default',
      redirect: { name: 'UserStart' },
    },
  ])),
});

// See Vue Router issue https://github.com/vuejs/vue-router/issues/2110
// Ensure that optional :market route param, as root route, is preserved when navigating (if present in the url before navigation)
// modified workaround found here: https://github.com/vuejs/vue-router/issues/2110#issuecomment-1177700932
// see also customVueRouter.js
router.beforeEach((to, from, next) => {
  // Append the :market param to the 'to' route if it exists on the 'from' route.
  if (from.params && from.params.market) {
    if (to.params)
      to.params.market = from.params.market;
    else
      to.params = { market: from.params.market };
  }
  // Force navigation with a defined :market param if the currently resolved path doesn't include it
  if (to.params && to.params.market
    && to.fullPath != `/${to.params.market}`
    && !to.fullPath.startsWith(`/${to.params.market}/`)) {
    next({
      name: to.name,
      hash: to.hash,
      params: to.params,
      query: to.query,
    });
  } else {
    next();
  }
});

export default router;
